.tile {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-4) var(--space-5);
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  min-width: 0;
}

.head {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--text-tertiary);
}

.label {
  font-size: var(--text-2xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-wider);
  text-transform: uppercase;
}

.value {
  font-size: var(--text-2xl);
  font-weight: var(--weight-semibold);
  line-height: 1.1;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.valueMono {
  font-family: var(--font-mono);
  font-size: var(--text-xl);
}

.unit {
  margin-left: var(--space-1);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--text-tertiary);
}

.caption {
  font-size: var(--text-sm);
  color: var(--text-tertiary);
}

.accentBar {
  height: 2px;
  border-radius: var(--radius-pill);
  background: var(--accent);
  opacity: 0.8;
  width: 28px;
}
